module.exports = "/_next/static/images/Wallet-7ff1275f8c11d445ef6216662768c707.png";